import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useTrackOnce } from '#src/app/shared/hooks/tracking';

type Result = {
	trackStarterInfoClick: () => void;
};

export function usePetitionStarterInfoTracking(): Result {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();

	const trackOnce = useTrackOnce();

	return useMemo(
		() => ({
			trackStarterInfoClick: () => {
				void trackOnce('petition_starter_info_clicked', {
					petition_id: id,
				});
			},
		}),
		[trackOnce, id],
	);
}
